exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card.card--confirmation{max-width:870px;border-radius:15px}.v-card.card--confirmation .card-body .date{font-size:1rem;line-height:26px}.v-card.card--confirmation .card-body .flight{min-width:110px}.v-card.card--confirmation .card-body hr{border-top:2px dashed #9b9b9b;width:70px}.v-card.card--confirmation .card-body .price{font-family:Avenir;font-weight:700}@media screen and (max-width:1550px){.v-card.card--confirmation .card-body .flight-container{margin:auto}}@media (min-width:1024px){.v-card.card--confirmation .card-body .lg\\:mt-0{margin-top:0!important}}@media screen and (min-width:1280px){.v-card.card--confirmation hr{width:110px}}.header-confirmation{text-align:center;margin:2rem 0}.header-confirmation p{font-size:16px;font-weight:900}.header-confirmation h2{font-size:24px;font-weight:900}.header-confirmation h2 span{color:#00adbc}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};